export default {
  // Settings Dashboard
  "settings.jumbotron.title": "Settings",
  "settings.jumbotron.description": "Configure system settings and business parameters.",
  "settings.search_placeholder": "Search settings...",
  "settings.desc.user_settings": "Profile photo, password, and account preferences",
  "settings.desc.company_info": "Company name, address, and contact details",
  "settings.desc.bank_accounts": "IBAN, BIC, and bank account numbers",
  "settings.desc.einvoice": "E-invoice address and operator",
  "settings.desc.accounting_settings": "Automatic vouchers and default VAT",
  "settings.desc.vat_configuration": "VAT rates and tax settings",
  "settings.desc.coa_configuration": "Chart of accounts structure",
  "settings.desc.coa_role_configs_configuration": "Account role mapping rules",
  "settings.desc.coa_groups_configuration": "Account group definitions",
  "nav.coa_groups_configuration": "Account Groups",
  "settings.desc.financial_years_configuration": "Fiscal year periods",
  "settings.desc.voucher_types_configuration": "Voucher type definitions",
  "settings.desc.entry_types_configuration": "Entry types: acquisition, depreciation, loan repayment and other voucher row types",
  "nav.dimensions_configuration": "Dimensions",
  "nav.charge_financing_balances": "Charge financing balances",
  "settings.desc.dimensions_configuration": "Accounting dimensions (cost centres, projects, etc.)",
  "settings.desc.currencies_configuration": "Currency codes and exchange rates",
  "nav.exchange_rates": "Exchange rates",
  "settings.desc.exchange_rates": "Daily ECB exchange rates",
  "settings.desc.units_configuration": "Units of measure",
  "settings.desc.stocks": "Stock locations and warehouses",
  "settings.desc.product_groups": "Product group definitions",
  "settings.desc.contact_groups": "Partner group definitions",
  "settings.desc.metered_units": "Metered units and their holders",
  "settings.desc.payment_terms_configuration": "Payment term definitions",
  "settings.desc.payment_methods_configuration": "Bank accounts and payment methods",
  "settings.desc.transfer_invoices": "Add advances and receivables as opening balances",
  "settings.desc.employees": "Employee records and information",
  "settings.desc.departments": "Department structure",
  "settings.desc.expense_categories_configuration": "Expense category definitions",
  "settings.desc.tenant_users": "Manage users and roles for this tenant",
  "settings.desc.role_management": "Define roles and module access permissions",
  "settings.desc.export_data": "Export company data",
  "nav.salaries_settings": "Salaries - Settings",
  "settings.desc.salaries_settings": "Payroll service settings",
  "settings.desc.stages_matrix": "Manage task stages and configure them per project",
  "settings.desc.project_tags": "Manage tags used to categorize tasks",
  "settings.desc.project_templates": "Define reusable project templates that pre-populate tasks for new projects",
  "settings.module.maventa": "Maventa",
  "settings.module.github_integration": "GitHub",
  "settings.module.metered_billing": "Metered billing",
  "settings.desc.github_integration": "Link pull requests and commits to tasks; close tasks on merge",
  "settings.module.company": "Company",
  "settings.module.accounting": "Accounting",
  "settings.module.invoicing": "Invoicing",
  "settings.module.purchasing": "Purchasing",
  "settings.module.inventory": "Inventory",
  "settings.module.crm": "CRM",
  "settings.module.hr": "HR",
  "settings.module.salaries": "Salaries",
  "settings.module.projects": "Projects",
  "settings.user_groups": "User Groups",
  "settings.desc.user_groups": "Manage user groups for approvals and other workflows",
  "settings.purchase_invoice_approval_rules": "Purchase Invoice Approval Rules",
  "settings.desc.purchase_invoice_approval_rules": "Approval rules and amount thresholds for purchase invoices",

  // Settings
  "settings.title": "User Settings",
  "settings.billing_info": "Billing Information",
  "settings.bank_details": "Bank Details",
  "settings.einvoice": "E-Invoice",
  "settings.security": "Security",
  "settings.change_password": "Change Password",
  "settings.company_logo": "Company Logo",
  "settings.upload_logo": "Upload Logo",
  "settings.remove_logo": "Remove Logo",
  "settings.company_info": "Company Information",
  "settings.email": "Email",
  "settings.billing_name": "Company Name",
  "settings.phone": "Phone",
  "settings.billing_street": "Street Address",
  "settings.billing_postcode": "Postal Code",
  "settings.billing_city": "City",
  "settings.billing_vat_number": "VAT Number",
  "settings.bank_name": "Bank Name",
  "settings.iban": "IBAN",
  "settings.bic": "BIC",
  "settings.einvoice_address": "E-Invoice Address",
  "settings.einvoice_operator": "E-Invoice Operator",
  "settings.current_password": "Current Password",
  "settings.new_password": "New Password",
  "settings.confirm_password": "Confirm Password",
  "settings.update_password": "Update Password",
  "settings.save_success": "Settings saved successfully",
  "settings.save_error": "Error saving settings",
  "settings.password_success": "Password updated successfully",
  "settings.password_error": "Error updating password",
  "settings.password_mismatch": "Passwords do not match",
  "settings.password_requirements": "Password must be at least 6 characters",
  "settings.profile_photo": "Profile Photo",
  "settings.upload_photo": "Upload Photo",
  "settings.photo_uploaded": "Photo uploaded successfully",
  "settings.photo_deleted": "Photo deleted",
  "settings.photo_upload_error": "Failed to upload photo",
  "settings.photo_delete_error": "Failed to delete photo",
  "settings.invalid_image_type": "Invalid image type. Please use JPEG, PNG, GIF, or WebP",
  "settings.image_too_large": "Image is too large. Maximum size is 5MB",
  "settings.click_to_upload": "Click photo to change",

  // Currencies
  "currencies.title": "Currencies",
  "currencies.create": "Create Currency",
  "currencies.edit": "Edit Currency",
  "currencies.code": "Currency Code",
  "currencies.marginal": "Marginal",
  "currencies.coa_sales_loss": "Sales Loss Account",
  "currencies.coa_sales_profit": "Sales Profit Account",
  "currencies.coa_purch_loss": "Purchase Loss Account",
  "currencies.coa_purch_profit": "Purchase Profit Account",
  "exchange_rates.currency": "Currency",
  "exchange_rates.rate": "Rate (1 EUR =)",
  "exchange_rates.date": "Date",
  "exchange_rates.source": "Source",
  "exchange_rates.as_of_date": "Date",
  "exchange_rates.showing_rates_for": "Rates for {{date}}",
  "exchange_rates.history_title": "{{currency}} rate history (1 EUR =)",
  "exchange_rates.no_history": "No rate history for this currency",
  "exchange_rates.select_tenant": "Select a company to view exchange rates",
  "exchange_rates.error.loading": "Failed to load exchange rates",
  "currencies.select_tenant": "Please select a tenant to view currencies.",
  "currencies.delete.confirm": "Are you sure you want to delete this currency?",
  "currencies.validation.code_required": "Currency code is required",
  "currencies.validation.code_length": "Currency code must be exactly 3 characters",
  "currencies.validation.marginal_required": "Marginal is required",
  "currencies.validation.marginal_min": "Marginal must be at least 0",
  "currencies.error.loading": "Error loading currency",
  "currencies.error.saving": "Error saving currency",
  "currencies.deleted": "Currency deleted successfully",
  "currencies.error.deleting": "Error deleting currency",
  "currencies.bulk.delete": "Delete Selected",
  "currencies.bulk.delete_confirm": "Are you sure you want to delete {{count}} currencies?",
  "currencies.bulk.deleted": "Currencies deleted successfully",
  "currencies.bulk.delete_error": "Error deleting currencies",

  // Payment Terms
  "payment_terms.title": "Payment Terms",
  "payment_terms.new": "New Payment Term",
  "payment_terms.create": "Create New Payment",
  "payment_terms.edit": "Edit payment term",
  "payment_terms.code": "Code",
  "payment_terms.code_required": "Code is required",
  "payment_terms.code_max_length": "Code must be at most 20 characters",
  "payment_terms.description": "Description",
  "payment_terms.description_required": "Description is required",
  "payment_terms.description_max_length": "Description must be at most 255 characters",
  "payment_terms.payment_days": "Payment Days",
  "payment_terms.payment_days_min": "Payment days must be at least 0",
  "payment_terms.payment_days_validate": "Payment days must be a whole number",
  "payment_terms.is_default": "Default Payment Term",
  "payment_terms.loading_error": "Error loading payment term",
  "payment_terms.save_error": "Error saving payment term",
  "payment_terms.delete.confirm": "Are you sure you want to delete this payment term?",
  "payment_terms.delete_error": "Error deleting payment term",
  "payment_terms.deleted": "Payment term deleted successfully",
  "payment_terms.error.deleting": "Error deleting payment term",
  "payment_terms.bulk.delete": "Delete Selected",
  "payment_terms.bulk.delete_confirm": "Are you sure you want to delete {{count}} payment terms?",
  "payment_terms.bulk.deleted": "Payment terms deleted successfully",
  "payment_terms.bulk.delete_error": "Error deleting payment terms",

  // VAT Configuration
  "vat.code": "Code",
  "vat.percent": "Percent %",
  "vat.description": "Description",
  "vat.sale_account": "Sales Account",
  "vat.buyin_account": "Purchase Account",
  "vat.type": "Type",
  "vat.group_id": "Group ID",
  "vat.select_tenant": "Please select a tenant to manage VAT settings.",
  "vat.state.active": "Active",
  "vat.state.deleted": "Deleted",
  "vat.state.invalid": "Invalid",
  "vat.confirm_delete_message": "Are you sure you want to delete this VAT rate?",
  "vat.delete.confirm": "Are you sure you want to delete this VAT rate?",
  "vat.deleted": "VAT deleted successfully",
  "vat.error.deleting": "Error deleting VAT",
  "vat.bulk.delete": "Delete Selected",
  "vat.bulk.delete_confirm": "Are you sure you want to delete {{count}} VATs?",
  "vat.bulk.deleted": "VATs deleted successfully",
  "vat.bulk.delete_error": "Error deleting VATs",

  // Financial Years
  "financial_years.name": "Name",
  "financial_years.start_date": "Start Date",
  "financial_years.end_date": "End Date",
  "financial_years.status": "Status",
  "financial_years.select_tenant": "Please select a tenant to manage financial years.",
  "financial_years.state": "State",
  "financial_years.state.open": "Open",
  "financial_years.state.locked": "Locked",
  "financial_years.lock": "Lock",
  "financial_years.unlock": "Unlock",
  "financial_years.locked": "Financial year locked",
  "financial_years.unlocked": "Financial year unlocked",
  "financial_years.delete.confirm": "Are you sure you want to delete this financial year?",
  "financial_years.lock.confirm": "Are you sure you want to lock this financial year? Locked years cannot be modified.",
  "financial_years.unlock.confirm": "Are you sure you want to unlock this financial year?",
  "financial_years.error.end_before_start": "End date must be after start date",
  "financial_years.error.locking": "Error locking financial year",
  "financial_years.error.unlocking": "Error unlocking financial year",
  "financial_years.deleted": "Financial year deleted successfully",
  "financial_years.error.deleting": "Error deleting financial year",
  "financial_years.bulk.delete": "Delete Selected",
  "financial_years.bulk.delete_confirm": "Are you sure you want to delete {{count}} financial years?",
  "financial_years.bulk.deleted": "Financial years deleted successfully",
  "financial_years.bulk.delete_error": "Error deleting financial years",
  "financial_years.voucher_number_start": "Voucher number start",
  "financial_years.voucher_number_end": "Voucher number end",
  "financial_years.error.number_range": "Number range exhausted",
  "financial_years.error.end_less_than_start": "End number must be greater than or equal to start number",

  // Cost Centres
  "cost_centres.code": "Code",
  "cost_centres.description": "Description",
  "cost_centres.is_default": "Default Cost Centre",
  "cost_centres.select_tenant": "Please select a tenant to manage cost centres.",
  "cost_centres.state.active": "Active",
  "cost_centres.state.deleted": "Deleted",
  "cost_centres.delete.confirm": "Are you sure you want to delete this cost centre?",
  "cost_centres.deleted": "Cost centre deleted successfully",
  "cost_centres.error.deleting": "Error deleting cost centre",
  "cost_centres.bulk.delete": "Delete Selected",
  "cost_centres.bulk.delete_confirm": "Are you sure you want to delete {{count}} cost centres?",
  "cost_centres.bulk.deleted": "Cost centres deleted successfully",
  "cost_centres.bulk.delete_error": "Error deleting cost centres",

  // Voucher Types
  "voucher_types.code": "Code",
  "voucher_types.description": "Description",
  "voucher_types.status": "Status",
  "voucher_types.select_tenant": "Please select a tenant to manage voucher types.",
  "voucher_types.state.active": "Active",
  "voucher_types.state.deleted": "Deleted",
  "voucher_types.delete.confirm": "Are you sure you want to delete this voucher type?",
  "voucher_types.deleted": "Voucher type deleted successfully",
  "voucher_types.error.deleting": "Error deleting voucher type",
  "voucher_types.bulk.delete": "Delete Selected",
  "voucher_types.bulk.delete_confirm": "Are you sure you want to delete {{count}} voucher types?",
  "voucher_types.bulk.deleted": "Voucher types deleted successfully",
  "voucher_types.bulk.delete_error": "Error deleting voucher types",

  // COA Role Configs
  "coa_role_config.select_tenant": "Please select a tenant to manage COA role configurations.",
  "coa_role_config.role_label": "Role",
  "coa_role_config.match_type_label": "Match Type",
  "coa_role_config.match_value": "Match Value",
  "coa_role_config.match_value_helper": "e.g., 2930 for parent_code, 4000-4999 for code_range",
  "coa_role_config.match_value_placeholder": "2930 or 4000-4999",
  "coa_role_config.match_type_helper": "How to match accounts to this role",
  "coa_role_config.priority": "Priority",
  "coa_role_config.priority_helper": "Higher priority rules are evaluated first",
  "coa_role_config.requires_vat_link": "Requires VAT Link",
  "coa_role_config.description": "Description",
  "coa_role_config.error.loading": "Error loading COA role configurations",
  "coa_role_config.error.deleting": "Error deleting configuration",
  "coa_role_config.delete.confirm": "Are you sure you want to delete this configuration?",
  "coa_role_config.deleted": "Configuration deleted successfully",
  "coa_role_config.bulk.delete": "Delete Selected",
  "coa_role_config.bulk.delete_confirm": "Are you sure you want to delete {{count}} configurations?",
  "coa_role_config.bulk.deleted": "Configurations deleted successfully",
  "coa_role_config.bulk.delete_error": "Error deleting configurations",
  "coa_role_config.seed_defaults.button": "Seed Defaults",
  "coa_role_config.seed_defaults.confirm": "This will add default role configurations. Continue?",
  "coa_role_config.seed_defaults.success": "Default configurations added successfully",
  "coa_role_config.seed_defaults.error": "Error adding default configurations",
  "coa_role_config.role.vat_payable": "VAT Payable",
  "coa_role_config.role.vat_receivable": "VAT Receivable",
  "coa_role_config.role.revenue": "Revenue",
  "coa_role_config.role.expense": "Expense",
  "coa_role_config.role.asset": "Asset",
  "coa_role_config.role.liability": "Liability",
  "coa_role_config.role.equity": "Equity",
  "coa_role_config.role.bank": "Bank",
  "coa_role_config.role.receivables": "Receivables",
  "coa_role_config.role.payables": "Payables",
  "coa_role_config.role.turnover": "Turnover",
  "coa_role_config.role.purchases": "Purchases",
  "coa_role_config.role.profit_loss": "Profit/Loss for Period",
  "coa_role_config.match_type.code_prefix": "Code Prefix",
  "coa_role_config.match_type.parent_code": "Parent Code",
  "coa_role_config.match_type.code_range": "Code Range",

  // Payment Methods
  "payment_methods.code": "Code",
  "payment_methods.description": "Description",
  "payment_methods.account_number": "Account Number",
  "payment_methods.account": "Account",
  "payment_methods.iban": "IBAN",
  "payment_methods.bic": "BIC",
  "payment_methods.service_id": "Service ID",
  "payment_methods.is_default": "Default Payment Method",
  "payment_methods.web_service_enabled": "Web Services enabled",
  "payment_methods.is_advance": "Advances method (account is the customer-advance account)",
  "payment_methods.select_tenant": "Please select a tenant to manage payment methods.",
  "payment_methods.state.active": "Active",
  "payment_methods.state.deleted": "Deleted",
  "payment_methods.delete.confirm": "Are you sure you want to delete this payment method?",
  "payment_methods.deleted": "Payment method deleted successfully",
  "payment_methods.error.deleting": "Error deleting payment method",
  "payment_methods.bulk.delete": "Delete Selected",
  "payment_methods.bulk.delete_confirm": "Are you sure you want to delete {{count}} payment methods?",
  "payment_methods.bulk.deleted": "Payment methods deleted successfully",
  "payment_methods.bulk.delete_error": "Error deleting payment methods",
  "payment_methods.banking_changed_warning": "Bank details have been changed or not yet approved. Web services are disabled until an admin approves this payment method.",
};
